/**
 * Builds an environment-aware URL. On QA: `{url}{branch}/{suffix}`, on prod: `{url}{suffix}`.
 *
 * @param {string} url - Base URL path
 * @param {Object} [options]
 * @param {string} [options.branch='__latest'] - QA-only branch inserted after the base path
 * @param {string} [options.suffix=''] - Extra path appended in every environment
 * @returns {string}
 */
export const getEnvironment = (url, {
  branch = '__latest',
  suffix = ''
} = {}) => {
  var _window$location;
  const isQA = typeof window !== 'undefined' ? (_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname.includes('develop---qa-autohero.classified.auto1-test.com') : process.env.ENV === 'qa';
  return isQA ? `${url}${branch}/${suffix}` : `${url}${suffix}`;
};